<template>
  <div class="row">
    <div class="col col-md-4">
      <div class="card mb-5 mb-xl-8">
        <!--begin::Body-->
        <div class="card-body pt-15 px-0">
          <!--begin::Member-->
          <div class="d-flex flex-column text-center mb-5 px-9">
            <!--begin::Info-->
            <div class="text-center">
              <!--begin::Name-->
              <span class="text-gray-800 fw-bold fs-4 mb-2">
                {{ currentEntity.name }}
              </span>
              <!--end::Name-->
              <div class="py-5 fs-6">

                <div class="fw-bold mt-5">Tipo</div>
                <div class="text-gray-600">
                  {{ currentEntity.type?.name }}
                </div>

                <div class="fw-bold mt-5">Producto</div>
                <div class="text-gray-600">
                  {{ currentEntity.product?.name }}
                </div>

                <div class="fw-bold mt-5">Idioma</div>
                <div class="text-gray-600">
                  {{ currentEntity.file_language }}
                </div>

                <div class="fw-bold mt-5">Fecha</div>
                <div class="text-gray-600">
                  {{ currentEntity.file_date }}
                </div>
              </div>
            </div>
            <!--end::Info-->
          </div>
          <!--end::Member-->
        </div>
        <!--end::Body-->
      </div>
    </div>
    <div class="col-12 col-md-8">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <!--begin::Wrapper-->
            <div class="card card-flush">
              <div class="card-body py-15 py-lg-20">
                <!--begin::Logo-->
                <div class="mb-5">
                  <i class="bi bi-shield-check fs-3hx me-4 text-primary"></i>
                </div>
                <!--end::Logo-->

                <!--begin::Title-->
                <h1 class="fw-bolder text-gray-900 mb-5">
                  Puedes iniciar la descarga
                </h1>
                <!--end::Title-->

                <div class="fs-6 text-gray-800 mb-5">
                  <p>
                    Tu plan actual permite la descarga de este archivo, pulsa el botón de abajo para iniciar la descarga.
                  </p>
                </div>

                <div class="fs-6 text-primary mb-5">
                  <button @click="downloadBlob(currentUser.currentPlan, currentEntity.type?.name)" class="btn btn-primary">Descargar</button>

                </div>
              </div>
            </div>
            <!--end::Wrapper-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {useConfigStore} from '~/stores/config';
import Swal from "sweetalert2/dist/sweetalert2.js";
import {onBeforeMount, ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useAuthStore} from "~/stores/auth";
import {usePublicDocumentsClientStore} from "~/stores/entities/client/publicDocumentsClient";
import {Plan} from "~/types/interfaces/entitites/PlanInterface";
import {useUtil} from "~/composables/useUtil";
import {number} from "yup";

export default {
  name: 'PublicDocumentsDownload',
  components: {

  },
  setup() {
    // Importantísimo definir el "alias" a cada página
    definePageMeta({
      alias: '/descargas/:hash/detalle',
      // middleware: [
      //   'downloads',
      // ],
    });
    const store = useAuthStore();
    const publicDocumentsClientStore = usePublicDocumentsClientStore();
    let automaticDownloads = ref<number>(0);

    const configStore = useConfigStore();
    const {setPageTitle, setBreadcrumb} = configStore;
    setPageTitle('Descargar archivo');
    const data = [
      {name: 'Archivos', link: '/descargas/listado'},
      {name: 'Listado', link: '/descargas/listado'},
      {name: 'Detalle', link: ''}
    ];
    setBreadcrumb(data);

    const {currentEntity, error} = storeToRefs(publicDocumentsClientStore);
    const {currentUser} = storeToRefs(store);
    const route = useRoute();

    watch(
        () => currentEntity.value.type,
        () => {
          checkAutomaticDownload();
          setPageTitle(currentEntity.value.name);
        }
    );

    watch(
        () => currentUser.value.currentPlan,
        () => {
          checkAutomaticDownload();
        }
    );

    onBeforeMount(async () => {
      await publicDocumentsClientStore.view(route.params.hash);

      if (error.value?.status !== undefined) {
        Swal.fire({
          title: error.value.status,
          text: error.value.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Entendido",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semibold btn-light-danger",
          },
        });
      }
    });

    const checkAutomaticDownload = () => {
      if (currentEntity.value.type && currentUser.value.currentPlan && route.query.download !== undefined) {
        if (automaticDownloads.value === 0) {
          downloadBlob(currentUser.value.currentPlan, currentEntity.value.type.name)
          automaticDownloads.value += +1;
        }
      }
    };

    const canDownload = (plan: Plan, fileType: string): boolean => {
      if (fileType === 'Estudio' || fileType === 'Ficha' || fileType === 'Infografía'|| fileType === 'Eventos') {
        return true;
      } else {
        return plan.name === 'Pleno+' || plan.name === 'Pleno' || plan.name === 'Pleno vulnerable';
      }
    };

    const downloadBlob = async (plan: Plan, fileType: string) => {
      if (canDownload(plan, fileType)) {
        useUtil().showLoading();

        // Perform an HTTP request to fetch the Blob data
        const response = await publicDocumentsClientStore.download(route.params.hash);

        // Create a URL for the Blob data
        const blobURL = window.URL.createObjectURL(response);

        // Create an <a> element to trigger the download
        const downloadLink = document.createElement('a');
        downloadLink.href = blobURL;
        downloadLink.download = currentEntity.value.slug + '.' + currentEntity.value.file_extension; // Set the desired file name

        // Trigger the download
        downloadLink.click();

        // Clean up by revoking the Blob URL
        window.URL.revokeObjectURL(blobURL);
        useUtil().closeLoading();
        useUtil().defaultDownloadSuccess();
      } else {
        useUtil().defaultError('Permiso denegado', 'Necesitas una suscripción superior para poder descargar estos archivos.');
      }
    };

    return {
      currentUser,
      currentEntity,
      downloadBlob
    }
  }
};
</script>

<style scoped></style>
